const generateSelectedItemsDescription = ({areAllSelected, targets}) => {
  if (areAllSelected) return 'all items matching current filters';

  if (targets.size > 1) return `${targets.size} mail items`;

  const firstItem = targets.first();

  return firstItem.context.type === 'trend_notification' ? 'trend' : firstItem.call.description;
};

export default generateSelectedItemsDescription;
